var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var DiseasesForm = require('./diseases-form');
var DeleteConfirmationModal = require('../common/delete-confirmation-modal');
var MedProfileModel = require('../../models/med-profile-model');
var ExacerbationsView = require('./exacerbations-view');

var CommonUtils = require('../../utils/common-utils.js');
var Dicts = require('../../data/dicts');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var utils = new CommonUtils();

var DiseasesRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/diseases-row.html'),

    ui: {
        edit: '.edit',
        remove: '.remove',
        showExacerbations: '.e-show'
    },

    events: {
        'click @ui.edit': 'onEdit',
        'click @ui.remove': 'onRemove',
        'click @ui.showExacerbations': 'showExacerbations'
    },

    templateContext: function () {
        var that = this;
        var startDate = that.model.get('startDate');
        var stopDate = that.model.get('stopDate');
        var typeOfId = that.model.get('typeOfId');
        return {
            startDate: startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '',
            stopDate: stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '',
            typeOfId: Dicts.hl7Dict[typeOfId] || typeOfId
        }
    },

    initialize: function (options) {
        var that = this;
    },

    onRender: function () {

    },

    onEdit: function() {
        this.triggerMethod('edit:disease', {model: this.model});
    },

    onRemove: function() {
        this.triggerMethod('remove:disease', {model: this.model});
    },

    showExacerbations: function() {
        this.triggerMethod('show:exacerbations', {exacerbations: this.model.get('exacerbations')});
    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(8), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var DiseasesTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: DiseasesRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {
        'remove:disease': 'removeDisease',
        'edit:disease': 'editDisease',
        'show:exacerbations': 'showExacerbations'
    },

    initialize: function (options) {
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {
        };
    },

    removeDisease: function(data) {
        this.triggerMethod('remove:disease', data);
    },

    editDisease: function(data) {
        this.triggerMethod('edit:disease', data);
    },

    showExacerbations: function(data) {
        this.triggerMethod('show:exacerbations', data);
    }
});

var DiseasesView = Marionette.View.extend({
    template: require('../../templates/medicals/diseases.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        diseasesForm: '#disease-form',
        deleteConfirmationModal: '#delete-confirmation-modal',
        exacerbationsShowRegion: '#exacerbation-show'
    },

    ui: {
        addDisease: '#add',
        exacerbationShowModal: '#exacerbation-show-modal'
    },

    events: {
        'click @ui.addDisease': 'addNewDisease'
    },

    childViewEvents: {
        'new:disease': 'saveNewDisease',
        'update:disease': 'updateDisease',
        'remove:disease': 'removeDisease',
        'delete:confirmed': 'deleteConfirmed',
        'edit:disease': 'editDisease',
        'show:exacerbations': 'showExacerbations'
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit,
            name: that.name
        }
    },


    initialize: function (options) {
        _.bindAll(this, 'addNewDisease');
        if (options) {
            this.medProfileModel = options.medProfileModel;
            this.name = options.name;
            this.canEdit = options.canEdit
        }
        this.servicesAddresses = services.request('get:services:address');
    },

    onRender: function () {
        var that = this;

        var diseases = that.medProfileModel.get('object').diseases;
        this.diseasesCollection = new Backbone.Collection(diseases);
        this.showChildView('body', new DiseasesTableBody({
            collection: this.diseasesCollection
        }));

        this.exacerbationsView = new ExacerbationsView({
            exacerbations: [],
            isReadOnly: true
        });
        this.showChildView('exacerbationsShowRegion', this.exacerbationsView);
    },

    addNewDisease: function () {
        this.showChildView('diseasesForm', new DiseasesForm({
            mode: 'add',
            disease: {},
            servicesAddresses: this.servicesAddresses
        }));
    },

    editDisease: function (data) {
        this.showChildView('diseasesForm', new DiseasesForm({
            mode: 'edit',
            disease: data.model.toJSON(),
            servicesAddresses: this.servicesAddresses
        }));
    },

    saveNewDisease: function (disease) {
        var that = this;
        utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/disease',
            data: JSON.stringify(disease),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.medProfileModel = new MedProfileModel(response);
                    that.diseasesCollection.reset(that.medProfileModel.get('object').diseases);
                }
            },
            error: function(e) {
                notificationsChannel.request('show:notification', e.responseJSON);
                utils.hideSpinner();
            }
        });
    },

    updateDisease: function(disease) {
        var that = this;
        utils.showSpinner();
        $.ajax({
            type: "PUT",
            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/disease',
            data: JSON.stringify(disease),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.medProfileModel = new MedProfileModel(response);
                    that.diseasesCollection.reset(that.medProfileModel.get('object').diseases);
                }
            },
            error: function(e) {
                notificationsChannel.request('show:notification', e.responseJSON);
                utils.hideSpinner();
            }
        });
    },

    deleteConfirmed: function(value) {
        if (value == true) {
            var that = this;
            var uuid = that.delModel.get('uuid');
            utils.showSpinner();
            $.ajax({
                type: "DELETE",
                url: '/api/medprofile/' + this.medProfileModel.get('id') + '/' + uuid,
                statusCode: {
                    200: function (response) {
                        utils.hideSpinner();
                        that.medProfileModel = new MedProfileModel(response);
                        that.diseasesCollection.reset(that.medProfileModel.get('object').diseases);
                    }
                },
                error: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                    utils.hideSpinner();
                }
            });
        }
    },

    removeDisease: function (data) {
        this.delModel = data.model;
        this.deleteConfirmationModal =
            new DeleteConfirmationModal({
                message: 'Enter: "confirm" if you agree to remove the disease.',
                confirmationAnswer: 'confirm'
            });
        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
        this.deleteConfirmationModal.show();
    },

    showExacerbations: function(data) {
        this.exacerbationsView.resetCollection(data.exacerbations || []);
        this.ui.exacerbationShowModal.modal('show');
    }

});

module.exports = DiseasesView;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/diseases-view.js
// module id = 356
// module chunks = 0